import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import type { AnchorInfo, PublicationItemInfo, TaskInfo } from "./useTaskDetailSubscription";
import type { ActionState, PreviewSibling, RestartUnfinishedUnitsState } from "./useTaskDetailActions";
import { IfPermission } from "../../auth/IfPermission";
import { AnchorRow } from "./AnchorRow";

export function AnchorsSection(props: {
  taskType: TaskInfo["taskType"];
  anchors: AnchorInfo[];
  publicationItems: PublicationItemInfo[] | null;
  onRegenerate: (anchorId: string) => void;
  regenerateState: ActionState;
  onRestartUnfinished: () => void;
  restartUnfinishedState: RestartUnfinishedUnitsState;
  onViewVariation: (variationId: string, siblings: PreviewSibling[]) => void;
}) {
  const isHomepage = props.taskType === "homepage_publication" || props.taskType === "sitewide_publication";
  const hasUnfinishedUnit = props.anchors.some(
    (anchor) => anchor.status === "failed" || anchor.status === "in_progress",
  );
  const canRestartUnfinished = hasUnfinishedUnit && props.publicationItems === null;
  const isRestartUnfinishedLoading = props.restartUnfinishedState.kind === "loading";

  return (
    <Box mb={3}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h6">Анкоры</Typography>
        {canRestartUnfinished && (
          <IfPermission permission="generation.manage">
            <Button
              size="small"
              variant="outlined"
              color="warning"
              onClick={props.onRestartUnfinished}
              disabled={isRestartUnfinishedLoading}
            >
              {isRestartUnfinishedLoading ? "…" : "Перезапустить незавершённые"}
            </Button>
          </IfPermission>
        )}
      </Stack>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Текст анкора</TableCell>
            {isHomepage && <TableCell align="right">Предложений</TableCell>}
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.anchors.map((anchor) => (
            <AnchorRow
              key={anchor.id}
              anchor={anchor}
              isHomepage={isHomepage}
              publicationItems={props.publicationItems}
              onRegenerate={props.onRegenerate}
              regenerateState={props.regenerateState}
              onViewVariation={props.onViewVariation}
            />
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export type ArticleInfo = AnchorInfo["articles"][number];
export type SentenceInfo = AnchorInfo["sentences"][number];
